import { useEffect, useState } from 'react';
import axios from '../helpers/axios'

export const createNewStaff = async (values, callback) => {
    const res = await axios.post(`/staff/createstaff`, values);

    if (res.status === 200) {
        callback(res.data.response);
    } else {
        callback(res.data.response)
    }
}

export const updateStaff = async (id, values, callback) => {
    const res = await axios.put(`/staff/updatestaff/${id}`, values);

    if (res.status === 200) {
        callback(res.data.response);
    } else {
        callback(res.data.response);
    }
}

export const deleteStaff = async (id, value, callback) => {
    const res = await axios.put(`/staff/deletestaff/${id}`, { updatedBy: value });

    if (res.status === 200) {
        callback(res.data.response);
    } else {
        callback(res.data.response);
    }
}

export const getAllStaffs = async (rowPerPage, pageNumber, search, callback) => {
    const res = await axios.get(`/staff/?rowPerPage=${rowPerPage}&pageNumber=${pageNumber}&search=${search}`);
    if (res.status === 200) {
        const staffList = res.data.response;
        callback(staffList)
    } else {
        callback(res.data.response);
    }
}

export const getStaffById = async (id, callback) => {
    axios.get(`/staff/${id}`).then(res => {

        if (res.status === 200) {
            callback(res.data.response.data);
        } else {
            callback(res.data.response.data)
        }
    })
}

export const getStaffsList = async (callback) => {
    axios.get(`/staff/allstaffs`).then(res => {

        if (res.status === 200) {
            callback(res.data.response.data);
        } else {
            callback(res.data.response.data)
        }
    })
}


export const StaffAPI = () => {
    const [staffs, setStaffs] = useState([]);
    const [allStaffs, setAllStaffs] = useState([]);
    const [staffDetail, setStaffDetail] = useState({});

    const [rowPerPage, setRowPerPage] = useState(10);
    const [search, setSearch] = useState("");
    const [pageNumber, setPageNumber] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [callback, setCallback] = useState(false);
    const [id, setId] = useState(0);

    useEffect(() => {
        getAllStaffs(rowPerPage, pageNumber, search, res => {
            setStaffs(res);
            setTotalPages(res.totalPage || 1)
        })

        getStaffById(id, res => {
            setStaffDetail(res);
        })

        getStaffsList(res => {
            setAllStaffs(res);
        })
    }, [callback, rowPerPage, search, pageNumber, id])

    return {
        staffs: [staffs, setStaffs],
        staffDetail: [staffDetail, setStaffDetail],
        allStaffs: [allStaffs, setAllStaffs],
        id: [id, setId],
        rowPerPage: [rowPerPage, setRowPerPage],
        search: [setSearch],
        pageNumber: [pageNumber, setPageNumber],
        totalPages: [totalPages, setTotalPages],
        callback: [callback, setCallback]
    }
}